var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_862_67942)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_862_67942",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_862_67942)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_862_67942",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0009 20H0.000854492V0H20.0009V20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_862_67942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1247 15.9197L6.86357 8.98779C6.29313 8.50913 5.44278 8.58339 4.96426 9.15366C4.48575 9.72393 4.56028 10.5743 5.13072 11.0529L13.3919 17.9848C13.9623 18.4635 14.8127 18.3892 15.2912 17.819C15.7697 17.2487 15.6952 16.3984 15.1247 15.9197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86417 11.0252L15.1253 4.09325C15.6958 3.61459 15.7703 2.76427 15.2918 2.194C14.8133 1.62373 13.9629 1.54947 13.3925 2.02813L5.13133 8.96006C4.56088 9.43872 4.48635 10.289 4.96487 10.8593C5.44338 11.4296 6.29373 11.5038 6.86417 11.0252Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_862_67942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.28d6e7abe2d50250b1f338d9d7477321.svg";
export { ForwardRef as ReactComponent };